/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_CreatingInputs */



/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Tournament_New_CreatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_creating = /** @type {((inputs?: Tournament_New_CreatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_CreatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione...")
	return /** @type {LocalizedString} */ ("Creating...")
});